<app-table-header
  (reload)="onRefreshList(false)"
  [loading]="loading"
  [withExportOption]="!!data.info.exportTableName"
  (exportBtnClicked)="exportBtnClicked()"
  >
  @if (!isVariant) {
    <button
      nz-button
      nzType="primary"
      style="margin-right: auto;"
      (click)="newDeliveryModalComponent.show(articleId, isVariant)"
    >Neue Lieferung</button>
  }
</app-table-header>
<nz-table appColumnLayout
  #tableRef
  [nzScroll]="{ x: tableMaxWidth }"
  nzShowSizeChanger
  [nzData]="data.results"
  [nzLoading]="loading"
  [nzTotal]="data.info.totalResults"
  [nzFrontPagination]="false"
  [nzPageSize]="pageSize"
  [nzPageIndex]="data.info.page"
  (nzQueryParams)="onQueryParamsChange($event)"
  appKeepState
  id="deliveries-list-table"
  >
  <thead>
    <tr>
      <th nzColumnKey="id" [nzSortFn]="true" nzWidth="75px" nzSortOrder="descend">#ID</th>
      <th nzColumnKey="deliveryDate" [nzSortFn]="true">Lieferdatum</th>
      <th nzColumnKey="supplier.name" [nzSortFn]="true">Lieferant</th>
      <th nzColumnKey="mhd" [nzSortFn]="true">MHD</th>
      <th nzColumnKey="charge" [nzSortFn]="true">Charge</th>
      <th nzColumnKey="quantity" [nzSortFn]="true">Menge</th>
      @if (!isVariant) {
        <th nzColumnKey="state.value" [nzSortFn]="true">Restmenge</th>
      }
      @if (!isVariant) {
        <th nzColumnKey="state.difference" [nzSortFn]="true">In Produktion</th>
      }
      <th nzColumnKey="pricePerKg">
        {{ !isVariant ? 'Preis netto pro Kilo' : 'Preis netto pro Stück' }}
      </th>
      <th nzColumnKey="price" [nzSortFn]="true">Preis netto</th>
      <th nzColumnKey="checked" [nzSortFn]="true">Wareneingang geprüft</th>
      @if (!isVariant) {
        <th nzColumnKey="status" [nzSortFn]="true">Status</th>
      }
      <th nzColumnKey="actions" nzRight></th>
    </tr>
  </thead>
  <tbody>
    @for (delivery of data.results; track delivery) {
      <tr>
        <td>#{{delivery.id}}</td>
        <td>{{delivery.deliveryDate|dateFormat}}</td>
        <td>
          <a [routerLink]="['/suppliers']" [queryParams]="{search: delivery.supplier.name}">{{delivery.supplier.name}}</a>
          @if (delivery.supplier.contactPerson || delivery.supplier.phoneNumber || delivery.supplier.email || delivery.supplier.comment) {
            <i nz-icon nzType="info-circle" nzTheme="outline"
              nz-tooltip
              [nzTooltipTitle]="delivery.supplier | supplierTooltip"
            style="margin-left: 4px; cursor: help;"></i>
          }
        </td>
        <td>{{delivery.mhd|dateFormat}}</td>
        <td>{{delivery.charge}}</td>
        <td>{{ delivery.quantity | productionUnit:!isVariant }}</td>
        @if (!isVariant) {
          <td>{{ delivery.state.value | productionUnit:true }}</td>
        }
        @if (!isVariant) {
          <td>{{ delivery.state.difference | productionUnit:!isVariant }}</td>
        }
        <td nzAlign="right" class="cell-numeric cell-nowrap">{{ delivery.pricePerKg ? (delivery.pricePerKg | currency) : '–' }}</td>
        <td nzAlign="right" class="cell-numeric cell-nowrap">{{ delivery.price ? (delivery.price | currency) : '–' }}</td>
        <td>{{delivery.checked | booleanFormat}}</td>
        @if (!isVariant) {
          <td>{{delivery.status | statusFormat}}</td>
        }
        <td nzRight>
          <div class="actions">
            <button
              type="button"
              nz-button
              nzType="text"
              nz-dropdown
              nzTrigger="click"
              [nzDropdownMenu]="menu"
              [attr.aria-label]="'Mehr Aktionen: Lieferung ' + delivery.id"
              nz-tooltip
              nzTooltipTitle="Mehr"
            >
              <i nz-icon nzType="more" nzTheme="outline"></i>
            </button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                @if (!isVariant) {
                  <li nz-menu-item (click)="openNewProductionOrder(delivery)">
                    Neuer Produktionsauftrag
                  </li>
                  <li nz-menu-divider></li>
                  <li nz-menu-item (click)="correctModal.show(delivery.id)">Inventurkorrektur</li>
                }
                <li nz-menu-item (click)="modal.showModal(delivery)">
                  <app-edit-modal (refresh)="onRefreshList(); deliveryEdited.emit()" #modal [isVariant]="isVariant">
                    <span trigger>Bearbeiten</span>
                  </app-edit-modal>
                </li>
                @if (delivery.ownProductionDocumentKey) {
                  <li nz-menu-item>
                    <app-download-document
                      class="full-width"
                      [documentKey]="delivery.ownProductionDocumentKey"
                      text="Protokoll"
                    ></app-download-document>
                  </li>
                }
                <li
                  nz-menu-item
                  nz-popconfirm
                  nzOkText="Ja"
                  nzCancelText="Nein"
                  nzPopconfirmTitle="Sind Sie sicher?"
                  (nzOnConfirm)="cancelBulkContainer(delivery.id)"
                >Löschen</li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </td>
      </tr>
    }
  </tbody>
</nz-table>
<app-correct-quantity-modal
  #correctModal
  (changeLogCreated)="onRefreshList(false); changeLogCreated.emit();"
></app-correct-quantity-modal>
<app-new-delivery-modal
  [articleId]="articleId"
  #newDeliveryModalComponent
  (deliveryCreated)="onRefreshList(false); deliveryCreated.emit()"
></app-new-delivery-modal>

<app-export-table-modal #exportTableModalComponent></app-export-table-modal>
